import type { ShapeCommand } from "../history/historyTypes";
import type { ActiveShape } from "./shapeTypes";

let shapeSequence = 0;

export function createShapeCommand(shape: Readonly<ActiveShape>): ShapeCommand {
  shapeSequence += 1;
  return Object.freeze({
    kind: "shape" as const,
    id: `shape-${shapeSequence}`,
    layerId: shape.layerId,
    tool: shape.tool,
    geometry: Object.freeze({
      start: Object.freeze({ ...shape.geometry.start }),
      end: Object.freeze({ ...shape.geometry.end }),
    }),
    style: Object.freeze({ ...shape.style }),
    clipRect: Object.freeze({ ...shape.clipRect }),
    ...(shape.panelId ? { panelId: shape.panelId } : {}),
    estimatedBytes: 320,
  });
}
